// Vị trí hiển thị quảng cáo (form tạo chiến dịch).
export const AD_PLACEMENTS = [
  { value: 'Feed', label: 'Feed' },
  { value: 'Reels', label: 'Reels' },
  { value: 'Video', label: 'Video' },
  { value: 'Profile', label: 'Trang cá nhân creator' },
  { value: 'HomeBanner', label: 'Banner trang chủ' },
  { value: 'PreRoll', label: 'Chèn trước video' },
];

export const HOME_BANNER = 'HomeBanner';
/** Quảng cáo chèn trước video và Reel, người xem bỏ qua được sau 5 giây. Chỉ nhận định dạng Video. */
export const PRE_ROLL = 'PreRoll';

/** Khung banner trang chủ: ảnh dọc tỉ lệ 363:488 (đúng ô ở cột phải trang chủ), kích thước gợi ý gấp đôi cho màn hình nét. */
export const HOME_BANNER_IMAGE = { width: 726, height: 976, ratio: 363 / 488 };

export const HOME_BANNER_HINT =
  'Banner trang chủ chỉ hiện ảnh và chỉ chạy khi chiến dịch chọn rõ vị trí này. Ảnh nên là ảnh dọc tỉ lệ 363:488, kích thước gợi ý 726×976 px.';

/** Nhãn ô chọn vị trí: để trống là mọi vị trí, riêng banner trang chủ và chèn trước video phải chọn rõ (khớp luật máy chủ). */
export const PLACEMENTS_PICKER_LABEL =
  'Vị trí hiển thị (để trống là mọi vị trí, trừ Banner trang chủ và Chèn trước video)';
export const HOME_BANNER_NEEDS_BANNER =
  'Banner trang chủ chỉ có khi chiến dịch chọn định dạng Banner.';

export const PRE_ROLL_HINT =
  'Chèn trước video phát video của bạn trước video và Reel, người xem bỏ qua được sau 5 giây. Video nên dài 6 đến 30 giây, khung ngang 16:9 hoặc dọc 9:16.';
export const PRE_ROLL_NEEDS_VIDEO = 'Chèn trước video chỉ có khi chiến dịch chọn định dạng Video.';

/** Gợi ý độ dài và khung video cho chèn trước video. Ngoài khoảng này chỉ cảnh báo, không chặn. */
export const PRE_ROLL_VIDEO = { recommendMinSec: 6, recommendMaxSec: 30, warnOverSec: 60 };
export const PRE_ROLL_VIDEO_HINT = 'Video nên dài 6 đến 30 giây';

/** Khung video gần 16:9 hoặc 9:16 (lệch tối đa 15%). Thiếu kích thước thì coi như đạt. */
export const isVideoAspectOk = (width: number, height: number, tolerance = 0.15) => {
  if (!width || !height) return true;
  const r = width / height;
  return [16 / 9, 9 / 16].some((t) => Math.abs(r - t) / t <= tolerance);
};

/** Lệch quá 15% so với tỉ lệ khung thì ảnh sẽ bị cắt nhiều khi lên banner trang chủ. */
export const isImageRatioFar = (width: number, height: number, target = HOME_BANNER_IMAGE.ratio, tolerance = 0.15) => {
  if (!width || !height) return false;
  return Math.abs(width / height - target) / target > tolerance;
};

/**
 * Chiến dịch này có thể lên banner trang chủ không (khớp luật máy chủ): phân phối Tự động, định dạng Banner,
 * đã chọn rõ banner trang chủ. Để trống vị trí (mọi vị trí) không tính.
 */
export const runsOnHomeBanner = (format?: string, placements?: string[] | null, dist?: string) =>
  (!dist || dist === 'Auto') && format === 'Banner' && !!placements?.includes(HOME_BANNER);

/**
 * Chiến dịch này có thể chèn trước video không (khớp luật máy chủ): định dạng Video và đã chọn rõ chèn trước video.
 * Để trống vị trí không tính. Đích danh và Sàn vẫn chạy được ở đây vì đây là nội dung của creator.
 */
export const runsOnPreRoll = (format?: string, placements?: string[] | null) =>
  format === 'Video' && !!placements?.includes(PRE_ROLL);

export const CREATOR_ONLY_NOTE = 'Chỉ hiện trên reels, video và trang cá nhân của creator';
export const MAX_NAMED_CREATORS = 20;

/** Vị trí không phải nội dung creator: chiến dịch Đích danh/Sàn không chạy ở đây. */
const NON_CREATOR = ['Feed', HOME_BANNER];

/**
 * Vị trí cho người chạy quảng cáo chọn. Named/Marketplace chỉ chạy trên bề mặt creator: ẩn Feed và banner trang chủ.
 * Banner trang chủ chỉ nhận định dạng Banner, chèn trước video chỉ nhận định dạng Video: định dạng khác thì ẩn (khi biết định dạng).
 */
export const placementsForDistribution = (dist?: string, format?: string) =>
  AD_PLACEMENTS.filter((p) => {
    if ((dist === 'Named' || dist === 'Marketplace') && NON_CREATOR.includes(p.value)) return false;
    if (p.value === HOME_BANNER && format !== undefined && format !== 'Banner') return false;
    if (p.value === PRE_ROLL && format !== undefined && format !== 'Video') return false;
    return true;
  });

/** Bỏ khỏi danh sách đã chọn những vị trí không còn hợp với cách phân phối và định dạng mới. */
export const keepAllowedPlacements = (placements: string[] | null | undefined, dist?: string, format?: string) => {
  const allowed = placementsForDistribution(dist, format).map((p) => p.value);
  return (placements || []).filter((p) => allowed.includes(p));
};

const labelOf = (v: string) => AD_PLACEMENTS.find((p) => p.value === v)?.label ?? v;
const joinLabels = (vs: string[]) => vs.map(labelOf).join(', ');

export type PlacementChangePlan =
  | { blocked: true; message: string }
  | { blocked: false; placements: string[]; message?: string };

/**
 * Đổi định dạng hoặc cách phân phối có thể làm vài vị trí đã chọn không còn hợp. Bỏ một phần thì báo vị trí nào đã bỏ.
 * Bỏ hết thì danh sách thành rỗng, tức chiến dịch chạy ở mọi vị trí, rộng hơn hẳn điều người chạy quảng cáo đã chọn:
 * trường hợp này chặn việc đổi và nhắc chọn thêm vị trí khác trước.
 */
export const planPlacementChange = (
  placements: string[] | null | undefined,
  dist?: string,
  format?: string
): PlacementChangePlan => {
  const current = placements || [];
  const kept = keepAllowedPlacements(current, dist, format);
  const removed = current.filter((p) => !kept.includes(p));
  if (!removed.length) return { blocked: false, placements: kept };
  if (!kept.length) {
    return {
      blocked: true,
      message: `Chiến dịch đang chỉ chọn ${joinLabels(removed)}. Nếu đổi, ${removed.length > 1 ? 'các vị trí này' : 'vị trí này'} bị bỏ và chiến dịch sẽ chạy ở mọi vị trí. Bạn hãy chọn thêm vị trí khác trước khi đổi.`,
    };
  }
  return {
    blocked: false,
    placements: kept,
    message: `Vị trí ${joinLabels(removed)} đã được bỏ khỏi danh sách vì không hợp với lựa chọn mới.`,
  };
};
